import { data } from "./timezone-countrycode-data";

/**
 * Exposes method for guessing a country code out of a timezone.
 */
export class TimezoneToCountryCodes {

  /**
   * Guess by giving tz formatted timezone (eg: Europe/Copenhagen)
   */
    public static timezoneGuess(timezone: string, fallback?: string): string[] {
      return this.mapTimezoneToCountryCodes(timezone, fallback);
    }
  /**
   * Guess using current timezone
   */
    public static guess(fallback?: string): string[] {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return this.mapTimezoneToCountryCodes(timezone, fallback);
    }

    private static mapTimezoneToCountryCodes(timezone: string, fallback?: string): string[] {
      const match = data.find(m => m.tz.toLowerCase() === timezone.toLowerCase());

      if (match) return match.countryCodes;

      // If no matches use fallback if specified
      return fallback ? [fallback] : [];
    }
  }
